import axios from 'axios';
import { pickBy } from 'lodash';
import { apiLoginsPasswordResetUrl } from '../config';

/**
 * POST Password Reset.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {string} [props.emailAddress] - target emailAddress
 * @param {string} [props.loginId] - target loginId
 * @returns {Promise}
 */
const postPasswordReset = props => {
  const { emailAddress, loginId, requestConfig } = props;

  const method = 'post';
  const url = apiLoginsPasswordResetUrl;

  const data = pickBy(
    {
      emailAddress,
      loginId
    },
    property => typeof property !== 'undefined'
  );

  return axios({
    data,
    method,
    url,
    ...requestConfig
  });
};

export default postPasswordReset;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/postPasswordReset.js